import { Component, Input } from '@angular/core';
import { LandingIconName } from '../../models/landing.models';

/**
 * Icono inline sustituto de lucide-react, sin dependencia de ninguna librería de
 * iconos externa (ni Bootstrap Icons, ni Material Icons). Cada icono es un <svg>
 * propio, estilo trazo minimalista, seleccionado por nombre.
 */
@Component({
  selector: 'landing-inversores-icon',
  templateUrl: './landing-icon.component.html',
  styleUrls: ['./landing-icon.component.scss'],
})
export class LandingIconComponent {
  @Input() name!: LandingIconName;
}
